import { WISHLISTS_SDK_EVENTS } from "./constants";

class WishlistsSdkEvents
    implements Record<WISHLISTS_SDK_EVENTS, WISHLISTS_SDK_EVENTS>
{
    public readonly WISHLIST_ITEM_CREATED =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED;
    public readonly WISHLIST_ITEM_DELETED =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_DELETED;

    // DEPRECATED
    public readonly [WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED] =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_CREATED;
    public readonly [WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_DELETED] =
        WISHLISTS_SDK_EVENTS.WISHLIST_ITEM_DELETED;
}

export default WishlistsSdkEvents;
